import { useEffect, useState } from "react";
import { Copy, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Panel } from "@/components/extranet/StatusBadge";
import { http, errMsg } from "@/lib/api";

const BASE = process.env.REACT_APP_BACKEND_URL;

export default function IcalExportPanel({ propertyId, rooms }) {
  const [token, setToken] = useState("");
  useEffect(() => {
    http.get(`/extranet/properties/${propertyId}/channel/ical-export`).then((r) => setToken(r.data.token)).catch((e) => toast.error(errMsg(e)));
  }, [propertyId]);
  const link = (rid) => `${BASE}/api/ical/${token}/${rid}.ics`;
  const copy = (t) => { navigator.clipboard?.writeText(t); toast.success("Link disalin"); };
  const regen = async () => {
    if (!window.confirm("Buat ulang semua link iCal ekspor? Link lama di channel manager akan berhenti bekerja.")) return;
    try { const r = await http.post(`/extranet/properties/${propertyId}/channel/ical-export/regenerate`); setToken(r.data.token); toast.success("Link baru dibuat"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Panel title="iCal ekspor (dibaca channel manager)" testid="ical-export-panel" className="lg:col-span-2"
      action={<button data-testid="ical-export-regenerate" onClick={regen} className="flex items-center gap-1.5 text-sm font-semibold text-red-600 hover:underline"><RefreshCw className="h-3.5 w-3.5" /> Buat ulang link</button>}>
      <div className="grid gap-3 p-5">
        <p className="text-sm text-slate-600">Tempel link ini di channel manager (mis. Bookandlink → import iCal) per tipe kamar. Isinya semua booking dari Booking Engine yang masih aktif, supaya kamar ikut ditutup di channel. Data tamu tidak dibagikan, hanya kode booking & tanggal.</p>
        {rooms.map((r) => (
          <div key={r.id} className="grid items-center gap-2 sm:grid-cols-[180px_1fr_auto]">
            <span className="text-sm font-semibold">{r.name}</span>
            <Input readOnly data-testid={`ical-export-url-${r.id}`} value={token ? link(r.id) : "Memuat..."} className="font-mono-x text-xs" onFocus={(e) => e.target.select()} />
            <button data-testid={`ical-export-copy-${r.id}`} disabled={!token} onClick={() => copy(link(r.id))} className="rounded-md border border-slate-300 p-2 hover:bg-slate-50 disabled:opacity-40"><Copy className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </Panel>
  );
}
